<template>
 <ag-grid-vue
   :class="{ 'ag-theme-balham-dark' : isDark, 'ag-theme-balham' : !isDark }"
   :style="styleHeight"
   :columnDefs="columnDefs.value"
   :rowData="rowData.value"
   :getRowId="getRowId"
   :defaultColDef="defaultColDef"
   rowSelection="none"
   suppressRowClickSelection="true"
   animateRows="true"
   @cell-clicked="cellWasClicked"
   @grid-ready="onGridReady"
   @selection-changed="onSelectionChanged"
 >
 </ag-grid-vue>

</template>

<script setup>

import { useConnectionStore } from '@/stores/connectionStore';
 
import { AgGridVue } from "ag-grid-vue3";  // the AG Grid Vue Component
import { reactive, onMounted, ref } from "vue";

import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional theme CSS

import { watch } from 'vue'
import { computed } from "@vue/reactivity"
import { t } from '@/composables/translateText.js'

const gridApi = ref(null); // Optional - for accessing Grid's API

const emit = defineEmits(['player-click'])

const props = defineProps({
  playerList : {
      type : Array,
      default : []
  },
  playerListTrigger : {
      type : Number,
      default : 0
  },
  playerNameHeadingString : {
    type : String,
    default : "Name"
  },
  showPlayerCheckboxes : {
    type : Boolean,
    default : true
  }
  ,
  setOneCellValue : {
    type : Array,
    default : []
  },
  styleHeight : {
    type : String,
    default :  "style= 'height: 300px'" 
  }
})

const connectionStore = useConnectionStore()
const isDark = ref(connectionStore.getDarkmode != "light")

var selectedRows = []
var selectedNodes = []
var ignoreSelection = false

// Obtain API from grid's onGridReady event
const onGridReady = (params) => {
  gridApi.value = params.api;
};

const rowData = reactive({}); // Set rowData to Array of Objects, one Object per Row

// Each Column Definition results in one Column.
const columnDefs = ref({
  value: [
       { field: "name" , checkboxSelection : true, headerName: '*** ' + t('Loading Players'),
              resizable: true, width: 200, maxWidth: 300},
       { field: "games" , headerName : t("Games"), type: 'numericColumn', filter: 'agNumberColumnFilter', sort : "desc",
              width: 100, maxWidth: 100},
       { field: "rating" , headerName : t("Rating") , type: 'numericColumn', filter: 'agNumberColumnFilter', 
              width: 100, maxWidth: 100},
       { field: "recent" , headerName : t("Recent"), type: 'numericColumn', width: 100, maxWidth: 100}  ],
});

// DefaultColDef sets props common to all Columns
const defaultColDef = {
  sortable: true,
  filter: true,
  flex: 1
};

const styleHeight = computed({
    get() {
      return props.styleHeight
    }
  })

const showPlayerCheckboxes = computed({
    get() {
      return props.showPlayerCheckboxes
    }
  })

const players = computed({
    get() {
      return props.playerList
    }
  })

const playerListTrigger = computed({
    get() {
      return props.playerListTrigger
    },
    set(value) {
      //emit('subscribe:user', value)
    }
  })

const setOneCellValue = computed({
    get() {
      return props.setOneCellValue
    }
  })
  
watch(setOneCellValue, (newVal,oldVal) => {
  //console.log("****** set one cell value",newVal)
  const idString = newVal[0]
  const field = newVal[1]
  const value = newVal[2]
  var rowNode = gridApi.value.getRowNode(idString);
  if (rowNode !== undefined)
    rowNode.setDataValue(field, value);
})


watch(playerListTrigger, (newVal,oldVal) => {
  //console.log("in watch trigger ag-grid count ",newVal)
  //console.log("         Filtered on move in ag grid",props.playerNameHeadingString)
  //console.log("show Player Checkboxes",showPlayerCheckboxes.value)
  //const testData = [{id:3,games:10,rating:120}]
  rowData.value = players
  //console.log("columndefs",columnDefs.value.value)
  
  columnDefs.value.value[0].checkboxSelection = () => showPlayerCheckboxes.value
  columnDefs.value.value[0].headerName = props.playerNameHeadingString

  //console.log("column 1",columnDefs.value.value[0])

  if (selectedNodes.length > 0) {
    ignoreSelection = true
    selectedNodes[0].setSelected(false)
    selectedNodes = []
    selectedRows = []
  }

  gridApi.value.refreshCells()

  })

onMounted(() => {
  const testData = [{name:"Loading Player Names"}]
  rowData.value = testData

  //console.log("in on mounted ag-grid count ",players.length)
  //rowData.value = players
  
  /*
  fetch("https://www.ag-grid.com/example-assets/row-data.json")
       .then((result) => result.json())
       .then((remoteRowData) => (rowData.value = remoteRowData));
  */
  })

function getRowId(params)  {
  //console.log("Get ROW ID Called")
  return params.data.idString;
}
function cellWasClicked(event) { // Example of consuming Grid Event
  //console.log("cell was clicked", event);
}
function deselectRows() {
  gridApi.value.deselectAll()
}

function onSelectionChanged() {
  //console.log("row selected  ignore flag",ignoreSelection)
 
  selectedNodes = gridApi.value.getSelectedNodes()
  selectedRows = gridApi.value.getSelectedRows();
  if (selectedRows.length > 0) {
    //console.log("selected info ",selectedRows[0])
    if (ignoreSelection == false) 
      emit("player-click",selectedRows[0].id,selectedRows[0].name)
  }
  else {
    //console.log("deselected row")
    if (ignoreSelection == false)
      emit("player-click",0,"")

  }
  ignoreSelection = false
     // document.querySelector('#selectedRows').innerHTML =
      //  selectedRows.length === 1 ? selectedRows[0].athlete : '';
}
</script>

<style scoped>

</style>